const main = {
  px: 5,
  py: 3,
  bgcolor: 'primary.dark',
}

export const classes = {
  main,
}
